import NumberFormatHelper from '@/ui-kit/helpers/NumberFormatHelper';
import ChartDataBuilder from '../builder/chart-data-builder';

export default class SoldPricePerSqft {
  constructor(chartData, width) {
    return new ChartDataBuilder()
      .setChartConfig((builder) => builder.setWidth(width).setId('Price per Sqft'))
      .setColorsConfig((builder) => builder.setColors(['#009fd4', '#00dbff', '#365f7d', '#04a4ae', '#3e2c34']))
      .setStrokeConfig((builder) => builder.setWidth([2, 2, 2, 2, 2]))
      .setXAxisConfig((builder) => builder.setCategories(chartData.timeline))
      .setYAxisConfig(
        (builder) => builder
          .addYAxisItem((axisBuilder) => axisBuilder
            .setTitle('Average Price Per Sqft')
            .setLabelFormatter((value) => value && NumberFormatHelper.formatCurrency(value))),
      )
      .build();
  }
}
